
import { AxiosHelper } from '../helpers/AxiosHelper';


const ChangePassword = async (formData: FormData) => {
    return AxiosHelper.post('/User/ChangePassword', formData);
}

const UpdateProfile = async (formData: FormData) => {
    return AxiosHelper.post('/User/UpdateProfile', formData);
}

const SavePreferences = async (formData: FormData) => {
    return AxiosHelper.post('/User/SavePreferences', formData);
}

const List = async (formData: FormData) => {
    return AxiosHelper.post('/User/List', formData);
}

const AddEdit = async (formData: FormData) => {
    return AxiosHelper.post('/User/AddEdit', formData);
}

const Remove = async (formData: FormData) => {
    return AxiosHelper.post('/User/Remove', formData);
}

const ListRecentAccess = async (formData: FormData) => {
    return AxiosHelper.post('/User/ListRecentAccess', formData);
}

const UpdateRecentAccess = async (formData: FormData) => {
    return AxiosHelper.post('/User/UpdateRecentAccess', formData);
}


const UserService = {
    ChangePassword,
    UpdateProfile,
    SavePreferences,
    List,
    AddEdit,
    Remove,
    ListRecentAccess,
    UpdateRecentAccess
}

export default UserService;